import styled from 'styled-components';

export const Content = styled.div`
  width: 25%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

export const Message = styled.div`
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: left;
  font-size: 14px;
  color: darkgray;
`;
